// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getWarehouses } from "@insite/client-framework/Services/WarehouseService";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { useEffect, useState } from "react";

const excludedBranchCode = "999";

function isExcludedBranch(warehouse: WarehouseModel) {
    return [warehouse.name, warehouse.description, warehouse.shipSite].some(
        value => (value || "").trim() === excludedBranchCode,
    );
}

export function warehouseOptionLabel(warehouse: WarehouseModel) {
    const code = (warehouse.name || "").trim();
    const description = (warehouse.description || "").trim();
    if (description && description !== code) {
        return `${code} - ${description}`;
    }
    return description || code;
}

export function useContactUsBranches(pickupOnly = false) {
    const [warehouses, setWarehouses] = useState<WarehouseModel[]>([]);

    useEffect(() => {
        let cancelled = false;
        getWarehouses({
            search: "",
            latitude: 0,
            longitude: 0,
            radius: 25000,
            pageSize: 500,
            page: 1,
        })
            .then(result => {
                if (cancelled) {
                    return;
                }
                setWarehouses(
                    (result.warehouses || [])
                        .filter(warehouse => !isExcludedBranch(warehouse))
                        .sort((a, b) => (a.name || "").localeCompare(b.name || "")),
                );
            })
            .catch(() => {
                if (!cancelled) {
                    setWarehouses([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, []);

    if (!pickupOnly) {
        return warehouses;
    }

    const pickupWarehouses = warehouses.filter(warehouse => warehouse.allowPickup);
    return pickupWarehouses.length > 0 ? pickupWarehouses : warehouses;
}
